module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_25000_50000.da6276bc.png";